require('babel-core/external-helpers');
import 'babel-core/polyfill';

const minLoadTime = 2000;
const loadTime = window.performance ?
    Date.now() - window.performance.timing.navigationStart :
    minLoadTime;
setTimeout(() => document.body.className = "loaded", Math.max(0, minLoadTime - loadTime));

const appEl = document.getElementById('portal-container');
const Raven = require('./Raven');
const React = require('react');
const router = require('./router');
const TokenStore = require('./stores/TokenStore');
const UserActions = require('./actions/UserActions');
const UserStore = require('./stores/UserStore');
const hasCors = 'withCredentials' in new XMLHttpRequest();

if (hasCors) {
    try {
        require('./errors');
        require('./css/application.css');
        require('./analytics');
        require('./css/application.css');

        initStores();
        startActivityListener();

        router.run((Handler, state) => {
            Raven.setExtraContext({state});
            React.render(<Handler version={_VERSION} {...state} />, appEl);
            ga && ga('send', 'pageview', { page: state.path });
        });
    } catch (e) {
        Raven.captureException(e);

        throw e;
    }
} else {
    const Unsupported = require('./components/Unsupported');
    React.render(<Unsupported />, appEl);
}

const oldOnError = window.onerror;
window.onerror = handleError;
function handleError() {
    oldOnError && oldOnError.apply(this, arguments);

    if (PRODUCTION) {
        const LocalStorage = require('./util/LocalStorage');
        LocalStorage.clear();
    }

    // In the case we dont have cors, we dont want errors occuring overwriting
    // the unsupported component.
    if (hasCors && PRODUCTION) {
        router.stop();

        const GeneralError = require('./components/Error');
        React.render(<GeneralError />, appEl);
    } else if (!PRODUCTION && console) {
        console.error('General Error detected. Would have rendered Error component in production.');
    }
}

function initStores() {
    UserStore.on('credential-conflict', () => router.transitionTo('login-timeout'));
    UserStore.on('retroactive-timeout', () => TokenStore.setToken(null));
}

function startActivityListener() {
    $('body').on('click tap keypress', () => {
        UserStore.hmacNeedsRefresh() && !UserStore.isHmacRefreshing() && UserActions.refreshHmac();
    });
}



// WEBPACK FOOTER //
// ./app/portal.js